import React from "react";
import { FormattedMessage as FM } from "react-intl";
import { Divider, Form, Header, Menu, Responsive } from "semantic-ui-react";

import PriestProfileTab from "../../data/enums/PriestProfileTab";

interface IPriestProfileControllerProps {
    currentTab: string;
    editMode: boolean;
    setCurrentTab(newCurrentTab: string): void;
}

const PriestProfileController: React.FC<IPriestProfileControllerProps> = (props: IPriestProfileControllerProps) => {
    const { currentTab, setCurrentTab, editMode } = props;

    const handleCurrentTabChange = (e: any, { value }: any) => setCurrentTab(value);

    return (
        <>
            {editMode && <Responsive as={Divider} maxWidth={768} style={{ marginTop: "6em" }} />}
            <Form>
                <Header as="h1" className="controllerHeader">
                    <FM id="profile.profilePriest" />
                </Header>

                <Menu color="violet" fluid secondary size="huge" vertical>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.general}
                        id={PriestProfileTab.general}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.general}
                    >
                        <FM id="profile.generalData" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.family}
                        id={PriestProfileTab.family}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.family}
                    >
                        <FM id="menu.family" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.qualification}
                        id={PriestProfileTab.qualification}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.qualification}
                    >
                        <FM id="menu.qualification" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.placements}
                        id={PriestProfileTab.placements}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.placements}
                    >
                        <FM id="menu.placements" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.occupations}
                        id={PriestProfileTab.occupations}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.occupations}
                    >
                        <FM id="menu.occupations" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.disciplinaryMatters}
                        id={PriestProfileTab.disciplinaryMatters}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.disciplinaryMatters}
                    >
                        <FM id="menu.disciplinaryMatters" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.pathOfLife}
                        id={PriestProfileTab.pathOfLife}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.pathOfLife}
                    >
                        <FM id="menu.pathOfLife" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.lifePathOnTheMap}
                        id={PriestProfileTab.lifePathOnTheMap}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.lifePathOnTheMap}
                    >
                        <FM id="menu.pathOfLifeOnTheMap" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.references}
                        id={PriestProfileTab.references}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.references}
                    >
                        <FM id="menu.references" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.pictures}
                        disabled
                        id={PriestProfileTab.pictures}
                        value={PriestProfileTab.pictures}
                        // onClick={handleCurrentTabChange}
                    >
                        <FM id="menu.pictures" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.files}
                        disabled
                        id={PriestProfileTab.files}
                        value={PriestProfileTab.files}
                        // onClick={handleCurrentTabChange}
                    >
                        <FM id="menu.files" />
                    </Menu.Item>
                    <Menu.Item
                        active={currentTab === PriestProfileTab.notes}
                        id={PriestProfileTab.notes}
                        onClick={handleCurrentTabChange}
                        value={PriestProfileTab.notes}
                    >
                        <FM id="menu.notes" />
                    </Menu.Item>
                </Menu>
            </Form>
        </>
    );
};

export default PriestProfileController;
